/* Display helpers for the new video detail page. Pure functions, no business rules. */

const AGE_BADGES: Record<string, string> = {
  'Family Friendly': 'All ages',
  'Adults Supervision': 'PG',
  '18+': '18+',
  '21+': '21+',
};

/** Short badge text for the age label set by AlbumListComponent (stream_info.ageInfo). */
export function ageBadge(ageInfo: string): string | null {
  return ageInfo ? (AGE_BADGES[ageInfo] || ageInfo) : null;
}

/** Counts are only shown once there is something to show. */
export function showCount(value: any): boolean {
  return Number(value) > 0;
}

/** Genre and release year, skipping empty parts. */
export function metaParts(streamInfo: any): string[] {
  return [streamInfo?.subData, streamInfo?.subData_Release].filter(part => !!part);
}
